import { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { useAuth } from "context/AuthContext";
import { useLoading } from "context/LoadingContext";
import Api from "utils/Api";
import './lojasSemVendas.css';

const LojasSemVenda = () => {
  const { setLoading } = useLoading();
  const auth = useAuth();
  const Requicicao = new Api();

  const [Lista, setLista] = useState([]);
  const [duplicados, setDuplicados] = useState([]);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [viewMode, setViewMode] = useState("table"); // "table" ou "cards"
  const [modalVisible, setModalVisible] = useState(false); // Controle do modal
  const [filteredLista, setFilteredLista] = useState([]);

  const handleSearch = (searchValue) => {
    setGlobalFilterValue(searchValue.trim()); // Remover espaços extras
    const filtered = Lista.filter((item) => {
      const searchLower = searchValue.toLowerCase();
      return (
        item.operador?.toLowerCase().includes(searchLower) || 
        item.codigoLojaAtual?.toLowerCase().includes(searchLower)
      );
    });
    setFilteredLista(filtered);
  };
  

  const fetchEmpresas = async () => {
    try {
      const resposta = await Requicicao.Get({
        endpoint: "/Empresa/ObterTodosVendedor",
        config: auth.GetHeaders(),
      });
  
      if (resposta.codigoEstadoHttp === 200) {
        const empresas = resposta.objetoResposta;

        // Mapeia as empresas para determinar o operador primeiro
        const empresasComOperador = empresas.map((empresa) => {
          const { matrizId } = empresa;
  
          // Busca o operador na matriz, se aplicável
          let operadorAtual = empresa.operador || "N/A";
          if ((operadorAtual === "N/A" || !operadorAtual) && matrizId) {
            const matriz = empresas.find((e) => e.id === matrizId);
            operadorAtual = matriz ? matriz.operador : "N/A";
          }
  
          return {
            ...empresa,
            operador: operadorAtual,
          };
        });
  
        const empresasApenasFilial = empresasComOperador.filter((empresa) => {
            // Verifica se a empresa possui um `matrizId` válido
            const matriz = empresasComOperador.find((e) => e.id === empresa.matrizId);
            return matriz !== undefined; // Inclui apenas empresas com matriz
        })

        // Filtra as empresas com base no código da loja, após determinar o operador
        return empresasApenasFilial
          .filter(
            (empresa) =>
              empresa.codigoLojaAtual && empresa.codigoLojaAtual !== "N/A"
          )
          .map((empresa) => ({
            codigoLojaAtual: empresa.codigoLojaAtual,
            id: empresa.id,
            operador: empresa.operador,
            nomeFantasia: empresa.pessoa.apelidoOuNomeFantasia,
            razaoSocial: empresa.pessoa.nomeCompletoOuRazaoSocial,
            cnpj: empresa.pessoa.cpfOuCnpj,
          }));
      }
  
      return [];
    } catch (error) {
      console.error("Erro ao buscar empresas:", error);
      return [];
    }
  };

  const fetchUltimaVenda = async () => {
    try {
      const resposta = await Requicicao.Get({
        endpoint: "/Venda/ObterDetalhesUltimaVenda",
        config: auth.GetHeaders(),
      });
      if (resposta.codigoEstadoHttp === 200) {
        return resposta.objetoResposta.map((venda) => ({
          ...venda,
          dataCriacao: new Date(venda.dataCriacao),
        }));
      }
      return [];
    } catch (error) {
      console.error("Erro ao buscar última venda:", error);
      return [];
    }
  };

  const StateDataPage = async () => {
    try {
      setLoading(true);

      const [empresas, ultimaVenda] = await Promise.all([
        fetchEmpresas(),
        fetchUltimaVenda(),
      ]);

      // Identificar códigos duplicados
      const codigoCounts = empresas.reduce((acc, empresa) => {
        acc[empresa.codigoLojaAtual] = (acc[empresa.codigoLojaAtual] || 0) + 1;
        return acc;
      }, {});

      const duplicadosLista = empresas.filter(
        (empresa) => codigoCounts[empresa.codigoLojaAtual] > 1
      );

      setDuplicados(duplicadosLista);

      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0); // Normaliza a data de hoje para comparação

      const lojasComStatus = empresas.map((empresa) => {
        const venda = ultimaVenda.find(
          (v) => v.codigoLoja === empresa.codigoLojaAtual
        );

        let semVenda = false;

        if (!venda) {
          semVenda = true;
        } else {
          // Normaliza as datas para ignorar horas
          const dataCriacaoVenda = new Date(venda.dataCriacao.getFullYear(), venda.dataCriacao.getMonth(), venda.dataCriacao.getDate());
          const dataHoje = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());

          semVenda = dataCriacaoVenda.getTime() !== dataHoje.getTime();
        }

        return {
          ...empresa,
          dataVenda: venda ? venda.dataCriacao.toLocaleDateString("pt-BR") : "N/A",
          semVenda,
        };
      });

      const sortedLista = lojasComStatus.sort((a, b) => b.semVenda - a.semVenda);

      setLista(sortedLista);
      setFilteredLista(sortedLista);
    } catch (error) {
      console.error("Erro ao carregar os dados:", error);
    } finally {
      setLoading(false);
    }
  };

  const rowClass = (rowData) => (rowData.semVenda ? "bg-danger text-white" : "bg-success text-white");

  const renderCards = () => (
    <div id="cards-lojas-sem-venda">
      {filteredLista.map((item) => (
        <div
          key={item.id}
          className={`card ${item.semVenda ? "card-closed" : "card-open"}`}
        >
          <h2>{item.codigoLojaAtual}</h2>
          <p><strong>Operador:</strong> {item.operador}</p>
          <p><strong>CNPJ:</strong> {item.cnpj}</p>
          <p><strong>Razão Social:</strong> {item.razaoSocial}</p>
          <p><strong>Última Venda:</strong> {item.dataVenda}</p>
          <p><strong>GUID:</strong> {item.id}</p>
        </div>
      ))}
    </div>
  );

  useEffect(() => {
    if (auth.isAuthenticated()) {
      StateDataPage();
    }
  }, [auth]);

  useEffect(() => {
    // Atualiza a lista filtrada sempre que a Lista muda ou o valor global do filtro é alterado
    handleSearch(globalFilterValue);
  }, [Lista, globalFilterValue]);

  return (
    <div className="card p-3">
      {duplicados.length > 0 && (
        <div className="mb-3">
          <Message
            severity="warn"
            text="Códigos duplicados encontrados. Clique para detalhes."
            style={{ cursor: "pointer" }}
            onClick={() => setModalVisible(true)}
          />
        </div>
      )}
      <Dialog
        visible={modalVisible}
        style={{ width: '50vw' }}
        header="Códigos Duplicados"
        modal
        onHide={() => setModalVisible(false)}
      >
        <ul>
          {duplicados.map((dup) => (
            <li key={dup.codigoLojaAtual}>
              {dup.codigoLojaAtual} - {dup.nomeFantasia}
            </li>
          ))}
        </ul>
      </Dialog>
      <div className="d-flex justify-content-between mb-3">
        <div>
          <h5>Lojas sem vendas hoje ({new Date().toLocaleDateString("pt-BR")})</h5>
          <span className="me-3">Pesquisa:</span>
            <InputText
            value={globalFilterValue}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Pesquisa Global"
            />
        </div>
        <Button
          label={viewMode === "table" ? "Ver como Cards" : "Ver como Tabela"}
          icon={viewMode === "table" ? "pi pi-th-large" : "pi pi-table"}
          onClick={() => setViewMode(viewMode === "table" ? "cards" : "table")}
          className="mb-3"
        />
      </div>
      {viewMode === "table" ? (
        <DataTable
          value={filteredLista}
          paginator
          rows={500}
          emptyMessage="Nenhuma loja sem venda encontrada."
          rowClassName={rowClass}
        >
          <Column field="operador" header="Operador" sortable />
          <Column field="codigoLojaAtual" header="Código Loja" sortable />
          <Column field="razaoSocial" header="Razão Social" sortable />
          <Column field="cnpj" header="CNPJ" sortable />
          <Column field="dataVenda" header="Última Venda" sortable />
        </DataTable>
      ) : (
        renderCards()
      )}
    </div>
  );
};

export default LojasSemVenda;
